
import { Link } from 'react-router-dom';
import { products } from '../../../mocks/products';
import useScrollReveal from '../../../hooks/useScrollReveal';

interface RelatedProductsProps {
  currentId: string;
}

export default function RelatedProducts({ currentId }: RelatedProductsProps) {
  const related = products.filter((p) => p.id !== currentId);
  const { ref: headerRef, isVisible: headerVisible } = useScrollReveal({ threshold: 0.2 });
  const { ref: gridRef, isVisible: gridVisible } = useScrollReveal({ threshold: 0.1 });

  return (
    <section className="py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <h2
          ref={headerRef}
          className={`text-4xl font-black tracking-tight text-center mb-12 transition-all duration-600 ease-out ${
            headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          YOU MIGHT ALSO LIKE
        </h2>
        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 gap-8" data-product-shop>
          {related.map((product, index) => (
            <Link
              key={product.id}
              to={`/product/${product.id}`}
              className={`group cursor-pointer transition-all duration-600 ease-out ${
                gridVisible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-10 scale-95'
              }`}
              style={{ transitionDelay: gridVisible ? `${index * 150}ms` : '0ms' }}
            >
              <div className="relative overflow-hidden rounded-lg mb-4 bg-zinc-900">
                <div className="w-full h-[400px]">
                  <img
                    src={product.images[0]}
                    alt={product.name}
                    width="800"
                    height="400"
                    className="w-full h-full object-cover object-top transform group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="flex items-start justify-between">
                <div>
                  <span className="text-[11px] text-teal-400 font-semibold uppercase tracking-wider">
                    {product.category}
                  </span>
                  <h3 className="text-xl font-bold mt-1">{product.name}</h3>
                  <p className="text-sm text-gray-400">{product.tagline}</p>
                </div>
                <div className="text-right">
                  <div className="text-xl font-black">${product.price.toLocaleString()}</div>
                  <div className="text-xs text-gray-500 line-through">
                    ${product.originalPrice.toLocaleString()}
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
